import { environment } from '@app/environments/environment';
import {
    AccommodationPageLocationModel,
    AccommodationPageModel,
    EsResponseModel,
} from '@app/models/elastic-search';
import { EsServiceBase } from '@app/services/abstracts/es-service.base';

export class EsAccommodationPageService extends EsServiceBase {
    readonly #accommodationPage = 'noc-accommodation-page';
    readonly #accommodationPageIndexVersion = environment.ACCOMMODATION_PAGE_ES_VERSION;

    private static _instance: EsAccommodationPageService;

    protected get indexName(): string {
        return `${this.#accommodationPage}-${this.#accommodationPageIndexVersion}`;
    }

    public static get instance(): EsAccommodationPageService {
        if (!this._instance) {
            this._instance = new EsAccommodationPageService();
        }
        return this._instance;
    }

    public async loadAccommodationData(
        id: string | number,
    ): Promise<EsResponseModel<AccommodationPageModel>> {
        return await this.get<AccommodationPageModel>(this.indexName, id, '_doc', {
            _source_excludes: 'links',
        });
    }

    public async loadLocationData(
        id: string | number,
    ): Promise<EsResponseModel<AccommodationPageLocationModel>> {
        const response = await this.get<
            Omit<AccommodationPageLocationModel, 'location'> & {
                location?: {
                    longitude?: number;
                    latitude?: number;
                };
            }
        >(this.indexName, id, '_doc', {
            _source: 'location.longitude,location.latitude',
        });

        // Map Elasticsearch fields (longitude/latitude) to standardized format (lon/lat)
        const mappedResponse: EsResponseModel<AccommodationPageLocationModel> = {
            ...response,
            _source: {
                ...response._source,
                location:
                    response._source?.location &&
                    response._source.location.longitude &&
                    response._source.location.latitude
                        ? {
                              lon: response._source.location.longitude,
                              lat: response._source.location.latitude,
                          }
                        : undefined,
            },
        };

        return mappedResponse;
    }
}
